const EXPIRATION_MS = CONTINUE_AS_GUEST_EXPIRATION * 24 * 60 * 60 * 1000;

export default function useGuestCookie() {
    const expires = new Date(Date.now() + EXPIRATION_MS);

    return useCookie<boolean | null>(CONTINUE_AS_GUEST_FLAG, { expires, path: "/", default: () => false });
}
